import { ViewStateTypes } from '@common/enums/viewstate-types';
import { PSTFieldNames } from '@src/suite/common/data-models/fields/pst-field-names';
import { ViewStateOptions } from '@src/suite/common/data-models/navigation/viewstate-options';
import { ViewStateOptionsSerializer } from '@src/suite/common/data-models/serializers/serializers';

import { Record } from './record';
import { SingleViewStateRecord } from './single-viewstate-record';

export class AssignmentViewStateRecord extends SingleViewStateRecord {
    public initialize() {
        this.viewStateType = ViewStateTypes.ASSIGNMENT;
        super.initialize();
        this.viewStateLayout = ViewStateOptionsSerializer.Instance(Record.globalTablesService).initialize(this.viewStateType, PSTFieldNames.PSTViewStateLayout);
    }

    public get viewStateLayout(): ViewStateOptions {
        return this.getAs<ViewStateOptions>('PSTViewStateLayout');
    }
    public set viewStateLayout(value: ViewStateOptions) {
        this.set('PSTViewStateLayout', value);
    }

    public get assignmentGuid(): string {
        return this.getAs<string>('assignmentGuid');
    }
    public set assignmentGuid(value: string) {
        this.set('assignmentGuid', value);
    }
}
